import { useState } from 'react';

import clientHTTP from 'helpers/http-client';

export const usePost = (endpoint, config) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const startRequestState = () => {
    setError(null);
    setIsLoading(true);
  };

  const handleData = (value) => {
    setIsSuccess(true);
    setData(value);
  };

  const handleError = (exception) => {
    setIsSuccess(false);
    setError(exception);
  };

  const submit = async (payload) => {
    startRequestState();

    try {
      const result = await clientHTTP.post(endpoint, payload, config);
      handleData(result);
    } catch (exception) {
      handleError(exception);
    } finally {
      setIsLoading(false);
    }
  };

  return { data, error, isLoading, isSuccess, submit };
};
